import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.map.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { currentCmsCompanyId } from "@/common/fhtGlobalEnv";
import BroadsideContact from "./BroadsideContact";

var BroadsideContactList =
/** @class */
function (_super) {
  __extends(BroadsideContactList, _super);

  function BroadsideContactList(props) {
    return _super.call(this, props) || this;
  }

  BroadsideContactList.prototype.render = function () {
    var _this = this;

    var contacts;
    var isInCms = Boolean(currentCmsCompanyId);

    if (!this.props.contacts.length) {
      contacts = _jsx("span", __assign({
        className: "broadside-contacts__list-item-empty"
      }, {
        children: " \u6682\u65E0\u8054\u7CFB\u4EBA "
      }), void 0);
    } else {
      contacts = _jsx("ul", __assign({
        className: "broadside-contacts__list"
      }, {
        children: this.props.contacts.map(function (contact) {
          return _jsx("li", __assign({
            className: "broadside-contacts__list-item",
            "data-user-client-id": contact.clientId,
            onClick: function onClick(e) {
              e.preventDefault();

              _this.props.onClickContact(contact);
            }
          }, {
            children: _jsx(BroadsideContact, {
              contact: contact
            }, void 0)
          }), contact.clientId);
        })
      }), void 0);
    }

    return _jsxs("div", __assign({
      className: "broadside-contacts"
    }, {
      children: [_jsxs("div", __assign({
        className: !isInCms ? "broadside-contacts__title" : "broadside-contacts__title settings-theme_color"
      }, {
        children: ["\u5728\u7EBF\u8BE2\u95EE\xA0", _jsxs("span", __assign({
          className: "broadside-contacts__member-count"
        }, {
          children: [this.props.contacts.length, "\u4EBA"]
        }), void 0)]
      }), void 0), contacts, _jsx("span", {
        className: "broadside-tool__arrow broadside-tool__contacts-arrow"
      }, void 0)]
    }), void 0);
  };

  return BroadsideContactList;
}(React.Component);

export default BroadsideContactList;